import { AxiosRequestConfig } from 'axios';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from './queryKey';

export const fetchActiveContentContestIds = (
  queryClient: QueryClient,
  contestId: number,
  contentContestIds: number[],
  options?: AxiosRequestConfig,
) =>
  queryClient.fetchQuery({
    queryKey: contestsQueryKey.activeContentContestIds(contestId, contentContestIds),
    queryFn: () => ContestApi.getActiveContentContestIds(contestId, { contentContestIds }, options),
    staleTime: 1000 * 60 * 10,
  });

export const useGetActiveContentContestIdsQuery = (
  contestId: number,
  contentContestIds?: number[],
  options?: AxiosRequestConfig,
) => {
  const normalizedIds = contentContestIds ?? [];

  return useQuery({
    queryKey: contestsQueryKey.activeContentContestIds(contestId, normalizedIds),
    queryFn: () => ContestApi.getActiveContentContestIds(contestId, { contentContestIds: normalizedIds }, options),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 10,
  });
};
